import React from "react";
import { graphql } from "gatsby";
import { DeepNonNullable } from "ts-essentials";
import { CheckIcon } from "@heroicons/react/solid";
import Button from "@ui/Button";
import { useModal } from "@ui/Modals/ModalContext";
import FloatingAd from "./FloatingAd";

export const query = graphql`
  query FloatingBlogAd($locale: String!) {
    strapiFloatingBlogAd(locale: { eq: $locale }) {
      title
      Feature {
        name
      }
      ctaText
      ctaSimpleText
    }
    strapiGenericText(locale: { eq: $locale }) {
      noCreditCardNeeded
    }
  }
`;

const FloatingBlogAd: React.FC<{
  data: DeepNonNullable<Queries.FloatingBlogAdQuery>;
  sliceContext: {
    locale: string;
  };
  simpleCta?: boolean;
  bgOn3XL?: boolean;
}> = ({
  data: { strapiFloatingBlogAd, strapiGenericText },
  simpleCta = false,
  bgOn3XL = false,
}) => {
  const { showSignUpModal } = useModal();

  const buttonText = simpleCta
    ? strapiFloatingBlogAd.ctaSimpleText
    : strapiFloatingBlogAd.ctaText;

  return (
    <FloatingAd title={strapiFloatingBlogAd.title} bgOn3XL={bgOn3XL}>
      <>
        <ul className="ml-0 mb-6 grid w-full max-w-[680px] grid-cols-[repeat(auto-fill,minmax(200px,1fr))] gap-x-12 gap-y-1 text-white">
          {strapiFloatingBlogAd?.Feature?.map(({ name }, idx) => (
            <li className="my-0 grid grid-cols-[24px_1fr] gap-2" key={idx}>
              <CheckIcon className="h-6 w-6 text-accuRankerOrange-500" />
              <span className="text-left">{name}</span>
            </li>
          ))}
        </ul>
        <Button
          color="green"
          onClick={() => {
            showSignUpModal();
            window.gtag?.("event", "sign_up_step_1", {
              button_text: buttonText,
            });
          }}
          padding="small"
          className="mb-2 h-[48px] w-full max-w-sm text-sm"
        >
          {buttonText}
        </Button>
        <span className="text-center text-xs text-white">
          {strapiGenericText.noCreditCardNeeded}
        </span>
      </>
    </FloatingAd>
  );
};

export default FloatingBlogAd;
